import type { Enemy } from './enemies';

/** 最近存活敌人（可限距离）。 */
export function nearestEnemy(
  enemies: readonly Enemy[],
  x: number,
  y: number,
  maxDist = Infinity,
): Enemy | null {
  let best: Enemy | null = null;
  let bd = maxDist * maxDist;
  for (const e of enemies) {
    if (!e.active) continue;
    const dx = e.x - x;
    const dy = e.y - y;
    const d2 = dx * dx + dy * dy;
    if (d2 < bd) { bd = d2; best = e; }
  }
  return best;
}
